import FieldController from '../field.controller';
import { castToBoolean } from '../../../../../../lib/util';

class DateFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, DateTimeService, moment) {
    "ngInject";
    super($scope, $q, $translate, $log);
    this.moment = moment;

    this.DateTimeService = DateTimeService;
    this._datePickerOpened = false;
    this._datePickerOptions = {
      showWeeks: false,
    };
  }

  $onInit() {
    if (this.isDate(this.value)) {
      this.dateValue = this.moment(this.value).toDate();
    }
  }

  get datePickerOptions() {
    return this._datePickerOptions;
  }

  get datePickerOpened() {
    return this._datePickerOpened;
  }

  set datePickerOpened(opened) {
    this._datePickerOpened = opened;
  }

  get dateValue() {
    return this.rawValue;
  }

  set dateValue(dateValue) {
    if (this.isDate(dateValue)) {
      this.rawValue = dateValue;
      this.value = this.moment(dateValue).format("MM/DD/YYYY");
    }
  }

  get required() {
    return this.field && castToBoolean(this.field.required);
  }

  get editable() {
    if (this.field.editable) {
      return castToBoolean(this.field.editable);
    }
    return false;
  }

  openDatePicker(event) {
    this._datePickerOpened = true;
  }

  closeDatePicker() {
    this._datePickerOpened = false;
  }

  /**
   * Checks if the date creates a valid JS date
   * @param {*} toCheck The value we will check.
   * @returns boolean
   */
  isDate(toCheck) {
    let val = new Date(toCheck);
    return val instanceof Date && !isNaN(val);
  }
}

export default DateFieldController;
